<template>
  <div class="form__controls">
    <label v-if="label" class="form-field-label" :for="uid">
      {{ label }}<span v-if="required">*</span>
    </label>

    <input
      :id="uid"
      type="text"
      class="field fieldSemEspacamento"
      :value="modelValue"
      :maxlength="limit"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :placeholder="placeholder"
      @input="onInput"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
      aria-live="polite"
      :aria-invalid="erro ? 'true' : 'false'"
    />

    <small
      v-if="limit < 200"
      class="maxlen-counter text-gray-600 dark:text-gray-400"
    >
      <template v-if="currentLength < limit">
        Restam {{ limit - currentLength }} caracteres de {{ limit }}.
      </template>
      <template v-else> Limite de {{ limit }} caracteres atingido. </template>
    </small>

    <p v-if="erroDesc || erro" class="erro">
      <slot name="erro">Campo obrigatório.</slot>
    </p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "InputNome",
  // eventos que o componente emite
  emits: ["update:modelValue", "blur", "focus", "input"],

  props: {
    id: { type: String, default: "" },
    modelValue: { type: String, default: "" },
    label: { type: String, default: "Nome" },
    placeholder: { type: String, default: "" },
    // se precisar sobrepor o limite global em casos específicos
    max: { type: [Number, String], default: null },
    warnAt: { type: Number, default: 0.8 },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    autocomplete: { type: String, default: "off" },
    erroDesc: { type: String, default: "" },
    erro: { type: Boolean, default: false },
  },

  data() {
    return {
      // limite vindo da config (fallback 200)
      nomeLimitConfig: 200,
    };
  },

  computed: {
    ...mapGetters({
      getConfiguracoes: "GET_CONFIGURACOES",
    }),
    uid() {
      return this.id || `in-${Math.random().toString(36).slice(2, 10)}`;
    },
    limit() {
      const n = Number(this.max);
      if (!Number.isNaN(n) && n > 0) return n; // prioriza prop 'max'
      return Number(this.nomeLimitConfig || 200); // senão usa config carregada
    },
    currentLength() {
      return (this.modelValue || "").length;
    },
    ratio() {
      return this.limit ? this.currentLength / this.limit : 0;
    },
  },

  async mounted() {
    const KEY = "Habilitar quantidade de caracteres nos campos nome";
    this.nomeLimitConfig = Number(
      (await this.getConfiguracoes(KEY)?.Valor) ?? 200,
    );
  },

  async created() {
    // Busca a configuração no store UMA vez por app; se já tiver no cache do módulo, é instantâneo.
    const KEY = "Habilitar quantidade de caracteres nos campos nome";
    await this.fetchConfiguracao([KEY]);
  },

  methods: {
    ...mapActions({
      fetchConfiguracao: "FETCH_CONFIGURACOES",
    }),
    onInput(e) {
      const val = e?.target?.value ?? "";
      this.$emit("update:modelValue", val);
      this.$emit("input", val);
    },
  },
};
</script>

<style scoped>
.maxlen-counter {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  opacity: 0.8;
}
.erro {
  color: #d9534f;
  margin-top: 4px;
  font-size: 12px;
}
</style>
